module.exports = __webpack_public_path__ + "static/img/sanwei-1.05d75307.png";